/* eslint camelcase: 0 */
import { ProfileRequest, User } from '@/infrastructure/network/Monitaro/schema/models'
import { IUserProps, EmptyUserPropsFactory } from '@/entities/User'
import { EmptyFilePropsFactory } from '@/entities/File'

export const toUserProps = (props: User | null | undefined): IUserProps => {
  if (!props) {
    return EmptyUserPropsFactory()
  }

  const {
    id,
    company_id,
    company,
    industry_id,
    industry,
    office_id,
    hospitals,
    pharmaceuticals,
    departments,
    username,
    login,
    fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    name,
    properties,
    flags,
    job,
    supervisor,
    payments,
    application,
    maintenance,
    certificate,
    files,
    provider,
    status,
    activation,
    withdrawed_at,
    locked_at,
    canceled_at,
    stopped_at,
    created_at,
    updated_at
  } = props

  return EmptyUserPropsFactory({
    id,
    companyId: company_id,
    company,
    industryId: industry_id,
    industry,
    officeId: office_id,
    hospitals,
    pharmaceuticals,
    departments,
    username,
    login,
    fcmToken: fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    name,
    properties,
    flags,
    job,
    supervisor,
    payments,
    application,
    maintenance,
    certificate,
    files: {
      image: EmptyFilePropsFactory(files?.image),
      card: EmptyFilePropsFactory(files?.card)
    },
    status,
    provider,
    activation,
    withdrawedAt: withdrawed_at,
    lockedAt: locked_at,
    canceledAt: canceled_at,
    stoppedAt: stopped_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toProfileRequest = (props: IUserProps): ProfileRequest => {
  const { industryId, companyId, name, properties, job, supervisor, pharmaceuticals, pharmaceutical, departments, payments } = props

  return {
    company_id: companyId,
    industry_id: industryId,
    name: name!,
    properties: properties!,
    job: job!,
    supervisor: supervisor!,
    pharmaceuticals: pharmaceuticals?.map((prop) => prop.id!) || [],
    pharmaceutical,
    departments: departments?.map((prop) => prop.id!) || [],
    payments: payments!
  }
}
